import { Action, Reducer } from "redux";
import {
	ManagePackagesCountStatusState,
	ManagePackagesCountStatusTypes,
	ManagePackagesCountStatusActionTypes,
} from "./managePackagesCountStatusTypes";

export const INITIAL_STATE: ManagePackagesCountStatusState = {
	managePackagesCountStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const managePackagesCountStatusReducer: Reducer<ManagePackagesCountStatusState> = (
	state: ManagePackagesCountStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ManagePackagesCountStatusActionTypes;
	switch (actionTypes.type) {
		case ManagePackagesCountStatusTypes.GET_MANAGEPACKAGES_COUNT_STATUS:
			return {
				...state,
				managePackagesCountStatus: {
					...state.managePackagesCountStatus,
					isLoading: true,
				},
			};
		case ManagePackagesCountStatusTypes.SAVE_MANAGEPACKAGES_COUNT_STATUS:
			return {
				...state,
				managePackagesCountStatus: {
					...state.managePackagesCountStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ManagePackagesCountStatusTypes.RESET_REDUCER_MANAGEPACKAGES_COUNT_STATUS:
			return {
				...state,
				managePackagesCountStatus: INITIAL_STATE.managePackagesCountStatus,
			};
		default:
			return state;
	}
};

export default managePackagesCountStatusReducer;
